/** @jsxImportSource @emotion/react */

import { Link } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import ClickupIcon from '../../assets/ClickupIcon'
import { s } from '../../style'
import {
  buildClickupAuthLink,
  fetchClickupClientId,
} from '../../utils/clickupConfig'

const ClickupAuthButton = ({ reload }) => {
  const [token, setToken] = useState()
  const [authLink, setAuthLink] = useState(null)

  useEffect(() => {
    const getToken = JSON.parse(localStorage.getItem('clickup'))
    if (getToken) setToken(getToken)
  }, [])

  useEffect(() => {
    let cancelled = false
    fetchClickupClientId()
      .then((clientId) => {
        if (!cancelled) setAuthLink(buildClickupAuthLink(clientId))
      })
      .catch(() => {
        if (!cancelled) setAuthLink(null)
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (reload)
    return (
      <a
        href={authLink || '#'}
        css={[sButton, { backgroundColor: 'lightgray' }]}
        onClick={(e) => {
          if (!authLink) e.preventDefault()
        }}
      >
        <ClickupIcon /> Autoryzuj ponownie
      </a>
    )
  if (!token)
    return (
      <a
        href={authLink || '#'}
        css={[
          sButton,
          {
            background: 'green',
          },
        ]}
        onClick={(e) => {
          if (!authLink) e.preventDefault()
        }}
      >
        <ClickupIcon /> Connect ClickUp
      </a>
    )
  return (
    <Link
      to='/clickup'
      css={[
        sButton,
        {
          background: `linear-gradient(110deg, #49CCF9, #8930FD, #FF02F0, #FFC800)`,
        },
      ]}
    >
      <ClickupIcon /> Connected
    </Link>
  )
}

const sButton = {
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.875rem',
  fontWeight: 'bold',
  color: 'white',
  svg: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '0.5rem',
  },
  height: 'max-content',
  padding: '0.5rem 1rem',
  borderRadius: '1rem',
  width: 'max-content',
  [s.xs]: {
    fontSize: '0.75rem',
  },
}

export default ClickupAuthButton
